module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-3-b8428ff431f90f591dd70a78f1b23158.jpg";